import { render, staticRenderFns } from "./addGeneralCategories.vue?vue&type=template&id=3173a50f"
import script from "./addGeneralCategories.vue?vue&type=script&lang=js"
export * from "./addGeneralCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports